export enum SortType {
  CHAPTER,
  NEWEST
}
